<template>
  <div
    class="ry-form__chart-container"
    :ref="`chartContainer_${current.chartId}`">
    <header v-if="![CHART_TYPE__TEXT, CHART_TYPE__CONTAINER_CHART].includes(current.chartType)">
      <span v-if="current.showPropertiesHolder.showTitle">{{current.title}}</span>
      <div class="chart-header__slot">
        <slot name="header"></slot>
      </div>
      <template v-if="type === CHART_STATUS_TYPE__EDIT">
        <div
          class="chart-handle__container"
          v-show="current.isHover">
          <el-button
            icon="el-icon-edit"
            @click.left="current.edit"
            title="编辑"
            type="text">
          </el-button>
          <el-button
            icon="el-icon-delete"
            @click.left="current.remove"
            title="删除"
            type="text">
          </el-button>
        </div>
      </template>
      <template v-else-if="type === CHART_STATUS_TYPE__VIEW">
        <div
          class="chart-handle__container">
          <el-button
            v-if="![CHART_TYPE__FILTER_BTN, CHART_TYPE__FILTER_CONTROL].includes(current.chartType)"
            class="full-screen-button"
            type="text"
            title="全屏"
            @click.left="actionFullScreen(true)"
            :icon="fullScreen ? 'iconfont icon-cancel-full-screen' : 'iconfont icon-full-screen'">
          </el-button>
          <el-button
            v-if="current.getValue"
            type="text"
            title="刷新"
            @click.left="current.getValue"
            icon="el-icon-refresh">
          </el-button>
        </div>
      </template>
      <div class="dash-top-pagination" :ref="`dashTopPag_${current.chartId}`">
        <van-button icon="arrow-left" @click="onClickLastChart">上一张</van-button>
        <van-button icon="arrow" icon-position="right" @click="onClickNextChart">下一张</van-button>
      </div>
    </header>
    <section :ref="`chartSection_${current.chartId}`" :style="{top: ![CHART_TYPE__TEXT, CHART_TYPE__CONTAINER_CHART].includes(current.chartType) ? '40px' : '0'}">
      <slot></slot>
    </section>
    <div
      v-if="type === CHART_STATUS_TYPE__EDIT"
      class="ry-form__chart-container-placeholder">
    </div>
    <div class="dash-pagination" :ref="`dashPag_${current.chartId}`">
      <van-button icon="arrow-left" @click="onClickLastChart">上一张</van-button>
      <van-button icon="arrow" icon-position="right" @click="onClickNextChart">下一张</van-button>
    </div>
  </div>
</template>

<script>
  import {
    CHART_TYPE__TEXT,
    CHART_STATUS_TYPE__EDIT,
    CHART_STATUS_TYPE__VIEW,
    CHART_TYPE__CONTAINER_CHART,CHART_TYPE__FILTER_BTN, CHART_TYPE__FILTER_CONTROL
  } from "../../types"
  import {arrayCompare} from "../../../../assets/js/Untis";

  export default {
    props: {
      value: Object,
      type: Number,
      nextChart: Function,
      lastChart: Function
    },
    data() {
      return {
        CHART_TYPE__TEXT,
        CHART_TYPE__CONTAINER_CHART,
        current: this.value,
        CHART_STATUS_TYPE__EDIT,
        CHART_STATUS_TYPE__VIEW,
        CHART_TYPE__FILTER_BTN,
        CHART_TYPE__FILTER_CONTROL,
        fullScreen: false,
        parentTransform: null,
        bgDiv: null,
        isWexinMini: false,
      }
    },
    created() {
      const ua = navigator.userAgent;
      const isWexin = /MicroMessenger/i.test(ua)
      this.isWexinMini = isWexin && (!this.$store.getters.env || this.$store.getters.env === 'smallProgram')
    },
    mounted() {
      var evt = "onorientationchange" in window ? "orientationchange" : "resize";
      const chartContainer = this.$refs[`chartContainer_${this.current.chartId}`]
      window.addEventListener("orientationchange", () => {
        setTimeout( () => {
          if (this.$children) {
            this.$children.forEach(el => {
              if (el && el.resize) {
                setTimeout(() => {
                  el.resize()
                }, 300)
              }
            })
          }

          if (this.fullScreen) {
            this.fullScreen = false
            const parent = this.$parent.$parent.$parent.$el
            parent.style.zIndex = 0
            parent.style.transform = this.parentTransform
            parent.removeChild(this.bgDiv)
            this.bgDiv = null
            this.actionFullScreen(false)
          }

        }  , 50 );

      }, false);
    },
    methods: {

      actionFullScreen(isFirst) {

        try {

          const chartContainer = this.$refs[`chartContainer_${this.current.chartId}`]
          const dashPag = this.$refs[`dashPag_${this.current.chartId}`]
          const dashTopPag = this.$refs[`dashTopPag_${this.current.chartId}`]
          const chartSection = this.$refs[`chartSection_${this.current.chartId}`]

          const parent = this.$parent.$parent.$parent.$el

          const btmFilter = document.querySelector('#btmFilter')

          if (chartContainer) {

            var width = document.documentElement.clientWidth;
            var height = document.documentElement.clientHeight;

            if (this.fullScreen) {

              if (btmFilter) {
                btmFilter.style.display = 'flex'
              }

              if (width < height) {
                // 竖屏
                chartContainer.style.transform = 'none';
                chartContainer.style.top = 0;
                chartContainer.style.left = 0;
                chartContainer.style.width = `${width}px`
                chartContainer.style.height = `${height}px`
                chartContainer.style.transformOrigin = `50% 50%`;
              }

              // 取消全屏
              chartContainer.style.position = 'relative'
              chartContainer.style.top = '0'
              chartContainer.style.width = '100%'
              chartContainer.style.height = '100%'
              chartContainer.style.zIndex = 0
              // chartContainer.style.background = this.bgStyle.background
              parent.style.zIndex = 0
              parent.style.transform = this.parentTransform
              parent.removeChild(this.bgDiv)
              this.bgDiv = null

              chartSection.style.bottom = '0'
              dashPag.style.display = 'none';
              dashTopPag.style.display = 'none';

              this.fullScreen = false
            } else {
              if (btmFilter) {
                btmFilter.style.display = 'none'
              }
              // 全屏
              this.parentTransform = parent.style.transform

              chartContainer.style.position = 'fixed'
              chartContainer.style.top = '0'
              chartContainer.style.left = '0'
              chartContainer.style.bottom = '0'
              chartContainer.style.right = '0'
              chartContainer.style.width = 'auto'
              chartContainer.style.height = 'auto'
              chartContainer.style.zIndex = 2
              // chartContainer.style.background = this.bgStyle.background
              parent.style.zIndex = 2
              parent.style.transform = 'none'

              this.bgDiv = document.createElement("div");

              this.bgDiv.style.position = 'fixed'
              this.bgDiv.style.top = '0'
              this.bgDiv.style.left = '0'
              this.bgDiv.style.bottom = '0'
              this.bgDiv.style.right = '0'
              this.bgDiv.style.width = 'auto'
              this.bgDiv.style.height = 'auto'
              this.bgDiv.style.zIndex = 1
              // this.bgDiv.style.background = this.dashBgStyle.background
              parent.appendChild(this.bgDiv)

              if (isFirst) {
                if (width < height) {
                  // 竖屏
                  chartContainer.style.transform = 'rotate(90deg)';
                  if (this.isWexinMini) {
                    chartContainer.style.top = `${(height - 34 - width)/2}px`;
                    chartContainer.style.left = `${0-(height - 34 -  width)/2}px`;
                    chartContainer.style.width = `${height - 34}px`
                  } else {
                    chartContainer.style.top = `${(height-width)/2}px`;
                    chartContainer.style.left = `${0-(height-width)/2}px`;
                    chartContainer.style.width = `${height}px`
                  }

                  chartContainer.style.height = `${width}px`
                  chartContainer.style.transformOrigin = `50% 50%`;

                  chartSection.style.bottom = '0'
                  dashTopPag.style.display = 'flex';
                } else {
                  chartSection.style.bottom = '0'
                  dashTopPag.style.display = 'flex';
                }
              } else {
                // 横屏
                chartContainer.style.transform = 'none';
                chartContainer.style.top = 0;
                chartContainer.style.left = 0;
                chartContainer.style.width = `${width}px`
                chartContainer.style.height = `${height}px`
                chartContainer.style.transformOrigin = `50% 50%`;

                if (width < height) {
                  chartSection.style.bottom = '50px'
                  dashPag.style.display = 'flex';
                  dashTopPag.style.display = 'none';
                } else {
                  chartSection.style.bottom = '0'
                  dashTopPag.style.display = 'flex';
                  dashPag.style.display = 'none';
                }
              }

              this.fullScreen = true
            }

            if (this.$children) {
              // const currentChart = this.$children.filter(el => el._name && el._name.includes('<Control'))[0]
              this.$children.forEach(el => {
                if (el && el.resize) {
                  setTimeout(() => {
                    el.resize()
                  }, 300)
                }
              })

            }
          }

        } catch (e) {
          console.log('full screen error', e)
        }
      },
      onClickLastChart() {
        if (this.lastChart) {
          this.lastChart()
        }
      },
      onClickNextChart() {
        if (this.nextChart) {
          this.nextChart()
        }
      }
    }
  }
</script>

<style rel="stylesheet" lang="less">
  .ry-form__chart-container {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    box-shadow: 0 5px 17px 0 rgba(0, 0, 0, 0.1);
    transition: height 200ms;
    border-radius: 8px;
    background: #fff;

    > header {
      height: 40px;
      padding: 0 12px;
      font-size: 0;
      line-height: 0;
      position: relative;

      > span {
        line-height: 40px;
        font-size: 14px;
        color: #1F2D3D;
        font-weight: 700;
        float: left;
        max-width: calc(100% - 100px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-wrap: break-word;
      }

      >.chart-header__slot {
        display: inline-block;
        height: 40px;
        width: auto;
        padding-left: 5px;
        float: left;
        z-index: 1;
      }

      > .chart-handle__container {
        position: relative;
        float: right;
        z-index: 4;
        display: flex;
        .el-button {
          margin: 0;
          padding-right: 6px;
          padding-left: 6px;
        }

        .el-icon-refresh {
          font-size: 16px;
        }

        .full-screen-button {
          margin-top: -3px;
          i {
            font-size: 12px;
          }
        }
      }

      .dash-top-pagination {
        position: absolute;
        width: 200px;
        left: calc(50% - 100px);
        height: 40px;
        top: 0;
        display: none;

        .van-button {
          border: none;
        }
      }
    }

    > section {
      position: absolute;
      top: 40px;
      left: 0;
      right: 0;
      overflow: auto;
      bottom: 0;
      background-color: transparent;
    }

    .dash-pagination {
      position: absolute;
      bottom: 0;
      height: 50px;
      width: 100%;
      display: none;
      align-items: center;
      justify-content: center;

      .van-button {
        border: none;
      }
    }

    > .ry-form__chart-container-placeholder {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
    }
  }
</style>
